export default "__VITE_ASSET__CfOX$13L__"